/** Query key builders for the event/event-card/event-details components' TanStack Query hooks.
 * Each `all(...)` prefix must be a strict prefix of its `detail(...)` key so that
 * `invalidateQueries({ queryKey: entity.all(id) })` catches every filtered variant. */
export const queryKeys = {
  geogroup: {
    all: geoGroupId => ['geogroup', geoGroupId]
  },
  game: {
    all: gameId => ['game', gameId]
  },
  gameTeams: {
    all: gameId => ['game-teams', gameId],
    detail: (gameId, groupIds) => ['game-teams', gameId, groupIds]
  },
  eventRanking: {
    all: eventId => ['event-ranking', eventId],
    detail: (eventId, params) => ['event-ranking', eventId, params]
  },
  eventIndividualRanking: {
    all: eventId => ['event-individual-ranking', eventId],
    detail: (eventId, params) => ['event-individual-ranking', eventId, params]
  },
  challengeLeaderboard: {
    all: challengeId => ['challenge-leaderboard', challengeId],
    detail: (challengeId, params) => ['challenge-leaderboard', challengeId, params]
  },
  challengeLeaderboardAll: {
    all: challengeId => ['challenge-leaderboard-all', challengeId]
  },
  userGeogroups: {
    all: parentId => ['user-geogroups', parentId]
  }
};